import { Routes, RouterModule } from '@angular/router';

// Route for content layout with sidebar, navbar and footer
export const Full_ROUTES: Routes = [
  {
    path: 'plan-produccion',
    loadChildren: () => import('../../workplan/workplan.module').then(m => m.WorkplanModule)
  },
  {
    path: 'administradores',
    loadChildren: () => import('../../admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'clientes',
    loadChildren: () => import('../../client/client.module').then(m => m.ClientModule)
  },
  {
    path: 'concesionarias',
    loadChildren: () => import('../../concessionaire/concessionaire.module').then(m => m.ConcessionaireModule)
  },
  {
    path: 'sectores',
    loadChildren: () => import('../../sector/sector.module').then(m => m.SectorModule)
  },
  {
    path: 'maquinas',
    loadChildren: () => import('../../machine/machine.module').then(m => m.MachineModule)
  },
  {
    path: 'ordenes-montaje',
    loadChildren: () => import('../../assembly-order/assembly-order.module').then(m => m.AssemblyOrderModule)
  },
  {
    path: 'configuracion-maquina',
    loadChildren: () => import('../../machine-settings/machine-settings.module').then(m => m.MachineSettingsModule)
  },
  {
    path: 'vendedores',
    loadChildren: () => import('../../seller/seller.module').then(m => m.SellerModule)
  },
  {
    path: 'tareas',
    loadChildren: () => import('../../task/task.module').then(m => m.TaskModule)
  },
  {
    path: 'incidencias',
    loadChildren: () => import('../../task-issue/task-issue.module').then(m => m.TaskIssuesModule)
  },
  {
    path: 'grupo-de-falla',
    loadChildren: () => import('../../categories-issue/categories-issue.module').then(m => m.CategoriesIssueModule)
  },
  {
    path: 'usuarios',
    loadChildren: () => import('../../user/user.module').then(m => m.UserModule)
  },
  {
    path: 'feriados',
    loadChildren: () => import('../../holiday/holiday.module').then(m => m.HolidayModule)
  },
  {
    path: 'flujos',
    loadChildren: () => import('../../flow/flow.module').then(m => m.FlowModule)
  },
  {
    path: 'planos',
    loadChildren: () => import('../../file/file.module').then(m => m.FileModule)
  }
];
